module.exports = __webpack_public_path__ + "static/media/mike_page.47a909d8.png";